// extracted by mini-css-extract-plugin
export default {"home":"Home_home__uEIM2","news":"Home_news__nYqxm","loader":"Home_loader__fbQAJ","articleContainer":"Home_articleContainer__OML+H"};